import { CurrentEventIdUpdate, SportType } from "../types";

const getOrganisation = (sport: string) => {
  switch (sport) {
    case SportType.Ufc:
      return "ufc";
    case SportType.Mma:
      return "pfl";
    default:
      return null;
  }
};

export async function getCurrentEventId(
  sport: string
): Promise<CurrentEventIdUpdate | null> {
  if (sport !== SportType.Ufc && sport !== SportType.Mma) {
    //? not supported
    return null;
  }

  try {
    const response = await fetch(
      `https://dixgwmlrk5btxsfzviip6hdhrm0tazmw.lambda-url.eu-west-1.on.aws/?sport=${getOrganisation(
        sport
      )}`
    );

    return await response.json();
  } catch (error) {
    return null;
  }
}
